import React, { FunctionComponent } from 'react';

import usePalette from '@gojob/ui-bits/styles/PaletteProvider/usePalette';
import Typography from '@gojob/ui-bits/Typography';
import GatsbyLink, { GatsbyLinkProps } from 'gatsby-link';

const Link: FunctionComponent<Omit<GatsbyLinkProps<{}>, 'color'>> = (props) => {
  const {
    typography: { link },
  } = usePalette();
  return <Typography as={GatsbyLink} variant="messageMedium" color={link} {...props} />;
};

export default Link;
